// extracted by mini-css-extract-plugin
module.exports = {"countdown":"ok","srOnly":"pk"};